import axios from 'axios'

const baseURL = process.env.VUE_APP_API_LARAVEL_URL

const axiosNodeInstance = axios.create({
  baseURL: `${baseURL}/api/v1`
})

axiosNodeInstance.defaults.headers.common.Accept = 'application/json'
axiosNodeInstance.defaults.headers.common.Version = '1.0.6'

export default axiosNodeInstance
